module.exports = __webpack_public_path__ + "static/media/russian-flag.10ddd77d.svg";